import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import { CiSearch } from "react-icons/ci";
import { Form, Table } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import UseToggle from "../../../Hooks/UseToggle";
import AddNewSDAData from "./AddNewSDAData";
import UpdateSDAMetadata from "./UpdateSDAMetadata";
import { FaEdit, FaTrash } from "react-icons/fa";
import Activities from "./Properties/Activities";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import TableProperties from "./Properties/TableProperties";
import Pagination from "../../Pagination";
import { useParams } from "react-router";
import PullSDAData from "./PullSDAData";
import ImportSDAData from "./Properties/ImportSDAData";

const SDAManagement = ({ onMouseDown, tableRef }) => {
  const toggles = UseToggle();
  const {studyId} = useParams();
  const [loader, setLoader] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [termsMetadata, setTermsMetadata] = useState([]);
  const [termsMetadataCount, setTermsMetadataCount] = useState(0);
  const [termsData, setTermsData] = useState("");
  const [isFormOpen, setIsFormOpen] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [activeTab, setActiveTab] = useState("activities");
  const [tableColumns, setTableColumns] = useState({});

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(termsMetadataCount / itemsPerPage);

   const formColumn = [
    {
      columnLabel: "Source Data Label",
      columnName: "SOURCEDATALABEL",
      columnType: "text",
    },
    {
      columnLabel: "Source Data Name",
      columnName: "SOURCEDATANAME",
      columnType: "text",
    },
    {
      columnLabel: "Source Variable Name",
      columnName: "SOURCEVARIABLENAME",
      columnType: "text",
    },
    {
      columnLabel: "Target Domain Label",
      columnName: "TARGETDOMAINLABEL",
      columnType: "text",
    },
    {
      columnLabel: "Target Domain Name",
      columnName: "TARGETDOMAINNAME",
      columnType: "text",
    },
    {
      columnLabel: "Target Variable Label",
      columnName: "TARGETVARIABLELABEL",
      columnType: "text",
    },
    {
      columnLabel: "Target Variable Name",
      columnName: "TARGETVARIABLENAME",
      columnType: "text",
    },
    {
      columnLabel: "Transpose",
      columnName: "TRANSPOSE",
      columnType: "text",
    },
    {
      columnLabel: "Source Variable Type",
      columnName: "SOURCEVARIABLETYPE",
      columnType: "text",
    },
    {
      columnLabel: "Function",
      columnName: "FUNCTION",
      columnType: "text",
    },
    {
      columnLabel: "Evaluator",
      columnName: "EVALUATOR",
      columnType: "text",
    },
    { columnLabel: "Codelist", columnName: "CODELIST", columnType: "select" },
    { columnLabel: "Assigned value", columnName: "ASSIGNEDVALUE", columnType: "select" },
    { columnLabel: "Edit", columnName: "EDIT", columnType: "action" },
    { columnLabel: "Delete", columnName: "DELETE", columnType: "action" },
  ];

  const getStudyCDISCSDA = async () => {
    setLoader(true);
    let data = await cdiscManagementService.getStudyCDISCSDA(studyId, searchData, pageNumber, itemsPerPage);
    setTermsMetadata(data?.data || []);
    setTermsMetadataCount(data?.count || 0);
    setLoader(false);
  };

   const downloadSDATemplate = async () => {
    let data = await cdiscManagementService.downloadSDATemplate();
    const csvContent = (data?.data || []).join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "SDA-Template.csv";
    link.click();
  };

  useEffect(() => {
    getStudyCDISCSDA();
  }, [studyId, searchData, pageNumber, itemsPerPage]);

  const updateTermsModal = (item) => {
    setTermsData(item);
    toggles.setToggle();
  };

  const deleteStudyCDISCSDA = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, delete it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        await cdiscManagementService.deleteStudyCDISCSDA(userData);
        getStudyCDISCSDA();
        setCategoryId("");
      }
    });
  };

  const [formActivity, setFormActivity] = useState([]);
  const [formActivityCount, setFormActivityCount] = useState(0);
  const [activityLoader, setActivityLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyCDISCSDAMetadata",
      studyId,
      termsData?.sdaId,
      pageNumber,
      itemsPerPage
    );
    setFormActivity(data?.data || []);
    setFormActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyCDISCSDAMetadata",
      studyId,
    );
    setTableColumns(data?.data || {});
  };

  useEffect(() => {
    getTablePropertiesData();
  }, []);
  
  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to update table property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.type = "studyCDISCSDAMetadata";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyCDISCSDA();
          getTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add SDA Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setCategoryId("");
            }}
            className={`fa-solid ${
              isFormOpen ? "fa-table-list" : "fa-plus-square CP"
            }`}
          />
          <div className="vr"></div>
          {termsMetadataCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "5px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 5, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <button
            onClick={() => toggles.setToggle4()}
            className={`updateProfile`}
            style={{ fontSize: 12 }}
          >
            Import
          </button>
          <button
            onClick={() => toggles.setToggle3()}
            className={`updateProfile`}
            style={{ fontSize: 12 }}
          >
            Pull Metadata
          </button>
          {termsMetadataCount > 0 && (
            <button
              onClick={() => toggles.setToggle2()}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Table Properties
            </button>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 181px)" }}
        minSize={categoryId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && <AddNewSDAData getStudyCDISCSDA={getStudyCDISCSDA} />}
          {loader ? (
            <PageLoader />
          ) : termsMetadata?.length === 0 ? (
            <NoDataFoundTable MSG={"SDA data not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped>
                <thead className="position-sticky top-0">
                  <tr>
                    <th onMouseDown={(e) => onMouseDown(e, 0)} style={{ width: 45 }} className="text-center">Sr.</th>
                     {!tableColumns["SOURCEDATALABEL"] && ( <th onMouseDown={(e) => onMouseDown(e, 1)}>Source Data Label </th>)}
                     {!tableColumns["SOURCEDATANAME"] && ( <th onMouseDown={(e) => onMouseDown(e, 2)}>Source Data Name</th>)}
                     {!tableColumns["SOURCEVARIABLENAME"] && ( <th onMouseDown={(e) => onMouseDown(e, 2)}>Source Variable Name</th>)}
                     {!tableColumns["TARGETDOMAINLABEL"] && ( <th onMouseDown={(e) => onMouseDown(e, 3)}>Target Domain Label</th>)}
                     {!tableColumns["TARGETDOMAINNAME"] && ( <th onMouseDown={(e) => onMouseDown(e, 4)}>Target Domain Name</th>)}
                     {!tableColumns["TARGETVARIABLELABEL"] && ( <th onMouseDown={(e) => onMouseDown(e, 5)}>Target Variable Label</th>)}
                     {!tableColumns["TARGETVARIABLENAME"] && ( <th onMouseDown={(e) => onMouseDown(e, 6)}>Target Variable Name</th>)}
                     {!tableColumns["TRANSPOSE"] && ( <th onMouseDown={(e) => onMouseDown(e, 7)}>Transpose</th>)}
                     {!tableColumns["SOURCEVARIABLETYPE"] && ( <th onMouseDown={(e) => onMouseDown(e, 8)}>Source Variable Type</th>)}
                     {!tableColumns["FUNCTION"] && ( <th onMouseDown={(e) => onMouseDown(e, 9)}>Function</th>)}
                     {!tableColumns["EVALUATOR"] && ( <th onMouseDown={(e) => onMouseDown(e, 10)}>Evaluator</th>)}
                     {!tableColumns["CODELIST"] && ( <th onMouseDown={(e) => onMouseDown(e, 11)}>Codelist</th>)}
                     {!tableColumns["ASSIGNEDVALUE"] && ( <th onMouseDown={(e) => onMouseDown(e, 12)}>Assigned value</th>)}
                     {!tableColumns["EDIT"] && ( <th onMouseDown={(e) => onMouseDown(e, 13)}  className="text-center" style={{ width: 60 }}>Edit</th>)}
                     {!tableColumns["DELETE"] && ( <th onMouseDown={(e) => onMouseDown(e, 14)}  className="text-center" style={{ width: 60 }}>Delete</th>)}
                  </tr>
                </thead>
                <tbody>
                  {termsMetadata?.map((item, index) => (
                    <tr key={index}
                      onClick={() => {
                        setIsFormOpen(false);
                        setCategoryId(item?._id);
                        setTermsData(item);
                      }}
                      className={`CP ${categoryId === item?._id ? "highlighted" : ""}`}
                      title="View Details"
                    >
                      <td className="text-center">{startIndex + index + 1}</td>
                      {!tableColumns["SOURCEDATALABEL"] && ( <td>{item.sourceDatasetLabel}</td>)}
                      {!tableColumns["SOURCEDATANAME"] && ( <td>{item.sourceDatasetName}</td>)}
                      {!tableColumns["SOURCEVARIABLENAME"] && ( <td>{item.sourceVariableName}</td>)}
                      {!tableColumns["TARGETDOMAINLABEL"] && ( <td>{item.targetDomainLabel}</td>)}
                      {!tableColumns["TARGETDOMAINNAME"] && ( <td>{item.targetDomainName}</td>)}
                      {!tableColumns["TARGETVARIABLELABEL"] && ( <td>{item.targetVariableLabel}</td>)}
                      {!tableColumns["TARGETVARIABLENAME"] && ( <td>{item.targetVariableName}</td>)}
                      {!tableColumns["TRANSPOSE"] && ( <td>{item.transpose}</td>)}
                      {!tableColumns["SOURCEVARIABLETYPE"] && ( <td>{item.sourceVariableType}</td>)}
                      {!tableColumns["FUNCTION"] && ( <td>{item.functionName}</td>)}
                      {!tableColumns["EVALUATOR"] && ( <td>{item.evaluatorName}</td>)}
                      {!tableColumns["CODELIST"] && ( <td>{item.codeList}</td>)}
                      {!tableColumns["ASSIGNEDVALUE"] && ( <td>{item.assignedValue}</td>)}
                      {!tableColumns["EDIT"] && ( <td
                          className="text-center CP"
                          title={`Update ${item.name}`}
                          onClick={(e) => {
                            updateTermsModal(item)
                            e.stopPropagation();
                          }}
                        >
                          <FaEdit className="text-muted" />
                        </td>
                      )}
                      {!tableColumns["DELETE"] && (
                        <td
                          className="text-center CP"
                          title={`Delete ${item.name}`}
                          onClick={(e) => {deleteStudyCDISCSDA(item?._id); e.stopPropagation();}}
                        >
                          <FaTrash className={"text-danger"} />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={termsMetadataCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
         {categoryId && (
            <div className={isFullScreen ? "full-screen-component" : ""}>
              <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
                <div className="hstack me-1 gap-1">
                  {["activities"].map((tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${
                        activeTab === tab ? "activee" : ""
                      }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  ))}
                </div>
                <div className="d-flex gap-1">
                  <div className="toolbar">
                    <i
                      className="fa-solid fa-angle-down"
                      onClick={() => setCategoryId(false)}
                    ></i>
                  </div>
                  <div className="toolbar">
                    <i
                      className={`fa-solid me-2 ${
                        !isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                      title={!isFullScreen ? "Full Mode" : "Original Mode"}
                      onClick={() => setIsFullScreen(!isFullScreen)}
                    ></i>
                  </div>
                </div>
              </div>
              {activeTab === "activities" && (
                <Activities
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                  formActivity={formActivity}
                  activityLoader={activityLoader}
                  formActivityCount={formActivityCount}
                  getStudyAuditTrials={getStudyAuditTrials}
                  termsData={termsData}
                />
              )}
            </div>
          )}
      </SplitPane>
      <TableProperties
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        buttonLoader={buttonLoader}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <UpdateSDAMetadata
        termsData={termsData}
        getStudyCDISCSDA={getStudyCDISCSDA}
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Update SDA Metadata"}
      />
      <PullSDAData
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        getStudyCDISCSDA={getStudyCDISCSDA}
        Title="Pull SDA Data"
      />
      <ImportSDAData
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        Title={"Import SDA Data"}
        studyId={studyId}
        getStudyCDISCSDA={getStudyCDISCSDA}
        downloadSDATemplate={downloadSDATemplate}
      />
    </>
  );
};

export default SDAManagement;
